import type { BaseComponentProps } from '@coursera/cds-common';

import { useCardContext } from '@core/cards/common/CardContext';
import { classes } from '@core/cards/common/getCommonCardCss';
import Typography from '@core/Typography2';

type Props = {
  /**
   * @example
   * metadata={[
   *   'Intermediate',
   *   'Professional Certificate',
   *   '6-12 months'
   * ]}
   */
  metadata: string[];
} & BaseComponentProps<'div'>;

/**
 * Common component to render card metadata such as product type, product duration, difficulty level.
 */
const CardMetadata = ({ metadata, ...rest }: Props) => {
  const context = useCardContext();
  const typographyVariant = context?.useCompactTypography
    ? 'bodyTertiary'
    : 'bodySecondary';

  return (
    <div className={classes.metadata} {...rest}>
      <Typography color="supportText" component="p" variant={typographyVariant}>
        {metadata.join(' · ')}
      </Typography>
    </div>
  );
};

export default CardMetadata;
